import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SafePipe } from '@siza-staff-care/shared/pipes';
import { MessageDialogModel } from './generic-dialogs.model';

@Component({
	template: `
		<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
			<h1 mat-dialog-title cdkDragHandle>{{ title }}</h1>
		</div>

		<div mat-dialog-content>
			@if (safeHtml) {
				<div [innerHTML]="message | safe"></div>
			}
			@if (!safeHtml) {
				<p>{{ message }}</p>
			}
		</div>

		<div mat-dialog-actions align="end">
			<button (click)="onClose()" mat-stroked-button color="primary">
				{{ closeButtonLabel }}
			</button>
		</div>
	`,
	standalone: true,
	imports: [CommonModule, SafePipe, DragDropModule, MatButtonModule, MatDialogModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageDialogComponent {
	title: string;
	message: string;
	closeButtonLabel: string;
	safeHtml: boolean;

	constructor(
		public dialogRef: MatDialogRef<MessageDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: MessageDialogModel,
	) {
		// Update view with given values
		this.title = data.title;
		this.message = data.message;
		this.closeButtonLabel = data.closeButtonLabel;
		this.safeHtml = !!data.safeHtml;
	}

	onClose(): void {
		this.dialogRef.close();
	}
}
